'use client';

import React, { useRef, FC } from 'react';

import { Carousel, CarouselProps, CarouselSlide } from '@mantine/carousel';
import Autoplay from 'embla-carousel-autoplay';

import '@mantine/carousel/styles.css';
import cx from './Carousel.module.css';

const InternalCarousel: FC<{ autoplay?: boolean; children: React.ReactNode } & CarouselProps> = ({
    autoplay = true,
    children,
    ...props
}) => {
    const autoplayRef = useRef(Autoplay({ delay: 3000 }));

    return (
        <Carousel
            slideSize="100%"
            slideGap="xl"
            controlSize={40}
            emblaOptions={{
                loop: true,
            }}
            plugins={autoplay ? [autoplayRef.current] : []}
            onMouseEnter={autoplay ? autoplayRef.current.stop : undefined}
            onMouseLeave={autoplay ? () => autoplayRef.current.play() : undefined}
            style={{ overflow: 'visible' }}
            classNames={{
                viewport: cx.viewport,
                controls: cx.controls,
                control: cx.control,
                indicators: cx.indicators,
                indicator: cx.indicator,
            }}
            {...props}
        >
            {children}
        </Carousel>
    );
};

export { InternalCarousel as Carousel, CarouselSlide };
